import React, {ChangeEvent, memo, useCallback, useEffect, useMemo, useRef, useState} from 'react';
import './index.scss';

import iconCancel from '../../assets/images/icons/scenario/cancel.png';
import iconSave from '../../assets/images/icons/scenario/save.png';
import iconTime from '../../assets/images/icons/scenario/time.png';
import iconSunrise from '../../assets/images/icons/scenario/sunrise.png';
import iconSunset from '../../assets/images/icons/scenario/sunset.png';
import iconScenario from '../../assets/images/icons/scenario/scenario.png';
import {useKeyboard} from '../../hooks/keyboard';
import {
    ScenarioModel,
    ScenarioTriggerModel,
    SunTimeType,
    TimeTriggerSettingsModel,
    TimeTriggerType,
} from '../../store/control/state';
import {useDispatch, useSelector} from 'react-redux';
import {toggleScenarioTriggerScreenAction} from '../../store/ui/actions';
import {useRPC} from '../../hooks/rpc';
import {useMessage} from '../../hooks/message';
import {onClickHandler} from '../../utils/onclick';
import {useLocalization} from '../../hooks/localization';

const format = (str: string) => {
    if (str.length === 1) {
        return "" + str[0] + "-:--"
    }
    if (str.length === 2) {
        return "" + str[0] + str[1] + ":--"
    }
    if (str.length === 3) {
        return "" + str[0] + str[1] + ":" + str[2] + "-"
    }
    if (str.length === 4) {
        return "" + str[0] + str[1] + ":" + str[2] + str[3]
    }

    return "--:--"
};

const formatMinute = (str: string) => {
    if (str.length === 1) {
        return "" + str[0] + "--"
    }
    if (str.length === 2) {
        return "" + str[0] + str[1] + "-"
    }
    if (str.length === 3) {
        return "" + str[0] + str[1] + str[2]
    }

    return "---"
}

const valid = (str: string, fullCheck = false) => {
    if (fullCheck && (!str || str.length !== 4)) {
        return false;
    }

    if (!str) {
        return true;
    }

    const hourFirst = parseInt(str[0]);
    if (hourFirst > 2) {
        return false;
    }

    if (str.length > 1) {
        const hour = parseInt(str[0] + str[1]);
        if (hour > 23) {
            return false;
        }
    }

    if (str.length > 2) {
        const minute = parseInt(str[2]);
        if (minute > 5) {
            return false;
        }
    }

    return true;
};

const validForMinute = (str: string, fullCheck = false) => {

    if (!str) {
        return true
    }

    return true
}

export const ScenarioTriggerCreateScreen = memo(function ScenarioTriggerCreateScreen() {
    const {t} = useLocalization();
    const scenarios = useSelector(state => state.control.scenarioList);
    const selectedTrigger = useSelector(state => state.ui.triggerScreen.selectedTrigger);
    const suntime = useSelector(state => state.control.suntime)


    const dispatch = useDispatch();
    const {failure} = useMessage();
    const [rpc] = useRPC();

    const inputRef = useRef<HTMLInputElement>();
    const timeRef = useRef<HTMLInputElement>();
    const diffRef = useRef<HTMLInputElement>();

    const [triggerName, setTriggerName] = useState('');
    const [timeStr, setTimeStrRaw] = useState('');
    const [diffStr, setDiffStrRaw] = useState('');

    const [scenarioId, setTriggerId] = useState('');

    const setTimeStr = useCallback((value: string) => {
        if (value) {
            value = value.replace(' ', '');
            if (value.length > 4) {
                value = value.substr(0, 4);
            }
        }
        setTimeStrRaw(value);
    }, []);

    const setDiffStr = useCallback((value: string) => {
        if (value) {
            value = value.replace(' ', '');
            if (value.length > 3) {
                value = value.substr(0, 3);
            }
        }
        setDiffStrRaw(value);
    }, []);

    const [setActiveInput, renderKeyboard] = useKeyboard();
    const [setActiveNumberInput, renderNumpad] = useKeyboard('numpad', true);

    const [triggerType, setTriggerType] = useState<TimeTriggerType>('exact');
    const [isBefore, setIsBefore] = useState(false);
    const [selectedScenario, setSelectedScenario] = useState<ScenarioModel>(null);

    const beforeAfterClicked = useCallback((isBeforeClicked: boolean) => {
        setIsBefore(isBeforeClicked);
        if (triggerType === 'exact') {
            setTriggerType('sunrise');
        }
    }, [triggerType]);

    const astronomicalTimeClicked = useCallback((isBeginningOfTheDay: boolean) => {
        if (triggerType === 'exact') {
            setIsBefore(true);
        }
        setTriggerType(isBeginningOfTheDay ? 'sunrise' : 'sunset');
    }, [triggerType]);

    const [selectedDays, setSelectedDays] = useState([true, true, true, true, true, true, true]);

    const dayClicked = useCallback((day: number) => {
        const days = [...selectedDays];
        days[day] = !days[day];
        setSelectedDays(days);
    }, [selectedDays]);

    const close = useCallback(() => {
        dispatch(toggleScenarioTriggerScreenAction(null));
    }, [dispatch]);

    const save = useCallback(() => {
        const dayList = selectedDays.map((selected, index) => selected ? index : -1).filter(index => index !== -1);
        if ((triggerType === 'exact' && !valid(timeStr, true)) || (triggerType !== 'exact' && !validForMinute(diffStr, true))) {
            failure(t('pls_enter_a_valid_time'));
            return;
        }

        if (!triggerName || triggerName.length < 3) {
            failure(t('pls_enter_a_valid_name'));
            return;
        }

        if (dayList.length === 0) {
            failure(t('pls_select_at_least_one_day'));
            return;
        }

        if (!selectedScenario) {
            failure(t('pls_select_a_scenario'));
            return;
        }

        let delayInSeconds;
        if (triggerType === 'exact') {
            delayInSeconds = (parseInt(timeStr[0] + timeStr[1]) * 60 + parseInt(timeStr[2] + timeStr[3])) * 60;
        } else {


            //delayInSeconds = (parseInt(diffStr[0] + diffStr[1]) * 60 + parseInt(diffStr[2] + diffStr[3])) * 60;
            delayInSeconds = (parseInt(diffStr[0] + diffStr[1] + diffStr[2]) * 60)

            console.log(delayInSeconds)
            if (isBefore) {
                delayInSeconds *= -1;
            }



        }

        const settings: TimeTriggerSettingsModel = {
            day_list: dayList,
            type: triggerType,
            delay_in_seconds: delayInSeconds,
        };

        const trigger: ScenarioTriggerModel = {
            id: scenarioId,
            name: triggerName,
            scenario_id: selectedScenario.id,
            settings: settings,
            is_passive: selectedTrigger?.is_passive || false,
            skip_count: selectedTrigger?.skip_count || 0
        }

        rpc.updateScenarioTrigger(trigger).then(isSucceeded => {
            if (isSucceeded) {
                close();
            }
        });

    }, [t, triggerType, timeStr, diffStr, triggerName, selectedDays, selectedScenario, scenarioId, rpc, failure, isBefore, close, selectedTrigger]);

    const onFocus = useCallback(() => {
        setActiveInput([inputRef, triggerName, setTriggerName]);
    }, [setActiveInput, triggerName]);

    const onBlur = useCallback(() => {
        setActiveInput(null);
    }, [setActiveInput]);

    const onChange = useCallback((e: ChangeEvent<HTMLInputElement>) => setTriggerName(e.target.value), []);

    const onFocusTime = useCallback(() => {
        setActiveNumberInput([timeRef, timeStr, setTimeStr]);
    }, [setTimeStr, setActiveNumberInput, timeStr]);

    const onBlurNumber = useCallback(() => {
        setActiveNumberInput(null);
    }, [setActiveNumberInput]);

    const onChangeTime = useCallback((e: ChangeEvent<HTMLInputElement>) => setTimeStr(e.target.value), [setTimeStr]);

    const onFocusDiff = useCallback(() => {
        setActiveNumberInput([diffRef, diffStr, setDiffStr]);
    }, [setDiffStr, setActiveNumberInput, diffStr]);

    const onChangeDiff = useCallback((e: ChangeEvent<HTMLInputElement>) => setDiffStr(e.target.value), [setDiffStr]);

    const time = useMemo(() => format(timeStr), [timeStr]);
    const diff = useMemo(() => formatMinute(diffStr), [diffStr])


    useEffect(() => {
        if (selectedTrigger) {
            setTriggerName(selectedTrigger.name);
            setTriggerId(selectedTrigger.id);
            setTriggerType(selectedTrigger.settings.type);

            const selectedDays = [false, false, false, false, false, false, false];
            for (const day of selectedTrigger.settings.day_list) {
                selectedDays[day] = true;
            }
            setSelectedDays(selectedDays);
            if (scenarios) {
                for (const scenario of scenarios) {
                    if (scenario.id === selectedTrigger.scenario_id) {
                        setSelectedScenario(scenario);
                        break;
                    }
                }
            }

            let second = selectedTrigger.settings.delay_in_seconds;
            if (second < 0) {
                second *= -1;
                setIsBefore(true);
            }

            const hour = Math.floor(second / 3600);
            const min = Math.floor((second % 3600) / 60);
            let hourStr = hour.toFixed(0);
            let minStr = min.toFixed(0);
            if (hourStr.length < 2) {
                hourStr = '0' + hourStr;
                if (hourStr.length < 2) {
                    hourStr = '0' + hourStr;
                }
            }

            if (minStr.length < 2) {
                minStr = '0' + minStr;
                if (minStr.length < 2) {
                    minStr = '0' + minStr;
                }
            }

            if (selectedTrigger.settings.type === 'exact') {
                setTimeStr(hourStr + minStr);
            } else {
                setDiffStr(String(second / 60))
            }
        }
    }, [scenarios, selectedTrigger, setDiffStr, setTimeStr]);

    return (
        <>
            <div className="content-page">
                <div className="content-divider top">
                    <div className="content-divider left">
                        <div className="content-top">
                            <div className="content-wrapper">
                                <div className="action-row">
                                    <div className="action" {...onClickHandler(close)}>
                                        <img src={iconCancel} alt="" />
                                        <span>{t("cancel")}</span>
                                    </div>
                                    <input
                                        maxLength={20}
                                        placeholder={t("enter_trigger_name")}
                                        ref={inputRef}
                                        onChange={onChange}
                                        className="highlighted"
                                        onFocus={onFocus}
                                        onBlur={onBlur}
                                        value={triggerName}
                                    />
                                    <div className="action" {...onClickHandler(save)}>
                                        <img src={iconSave} alt="" />
                                        <span>{t("save")}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="content-center">
                            <div className="child">
                                <div className="content-wrapper">
                                    <input
                                        style={{border: 0, background: "transparent", width: 0, height: 0}}
                                        maxLength={4}
                                        type="number"
                                        ref={timeRef}
                                        onChange={onChangeTime}
                                        onFocus={onFocusTime}
                                        onBlur={onBlurNumber}
                                        value={timeStr}
                                    />
                                    <span
                                        {...onClickHandler(() => timeRef.current.focus())}
                                        className={valid(timeStr) ? "" : "invalid"}
                                    >
                                        {time}
                                    </span>
                                    <div
                                        className={"check-box" + (triggerType === "exact" ? " checked" : "")}
                                        style={{borderRadius: "50%"}}
                                        {...onClickHandler(() => setTriggerType("exact"))}
                                    />
                                    <img src={iconTime} alt="" />
                                </div>
                            </div>

                            {/*<div className="child">
                                <div className="content-wrapper">
                                    <div className={"sun-container" + (triggerType !== "exact" ? " checked" : "")}>
                                        <div className="sun">
                                            <span>{t("before")}</span>
                                            <div
                                                className={"check-box-circle" + (isBefore ? " checked" : "")}
                                                {...onClickHandler(() => beforeAfterClicked(true))}
                                            />
                                            <img src={iconSunrise} alt="" />
                                            <small style={{color: "#fff"}}>{suntime.sunrise.slice(0, 5)}</small>
                                            <div
                                                className={
                                                    "check-box-circle" + (triggerType === "sunrise" ? " checked" : "")
                                                }
                                                {...onClickHandler(() => astronomicalTimeClicked(true))}
                                            />
                                        </div>
                                        <div className="sun">
                                            <span>{t("after")}</span>
                                            <div
                                                className={"check-box-circle" + (!isBefore ? " checked" : "")}
                                                {...onClickHandler(() => beforeAfterClicked(false))}
                                            />
                                            <img src={iconSunset} alt="" />
                                            <small style={{color: "#fff"}}>{suntime.sunset.slice(0, 5)}</small>
                                            <div
                                                className={
                                                    "check-box-circle" + (triggerType === "sunset" ? " checked" : "")
                                                }
                                                {...onClickHandler(() => astronomicalTimeClicked(false))}
                                            />
                                        </div>
                                    </div>
                                </div>
                                            </div>*/}

                            <div className="parent-child">
                                <div
                                    className="child"
                                    style={{
                                        width: "100%",
                                        minHeight: "142px",
                                        height: "100%",
                                        marginBottom: "3px",
                                        alignItems: "center"
                                    }}
                                >
                                    <div className="content-wrapper">
                                        <input
                                            style={{border: 0, background: "transparent", width: 0, height: 0}}
                                            maxLength={3}
                                            ref={diffRef}
                                            type="number"
                                            onChange={onChangeDiff}
                                            onFocus={onFocusDiff}
                                            onBlur={onBlurNumber}
                                            value={diffStr}
                                        />
                                        <span
                                            {...onClickHandler(() => diffRef.current.focus())}
                                            className={validForMinute(diffStr) ? "" : "invalid"}
                                        >
                                            {diff}'
                                        </span>
                                        <div className="trigger-special-row">
                                            <span>{t("before")}</span>
                                            <span>{t("after")}</span>
                                        </div>
                                        <div className="trigger-special-row">
                                            <div
                                                className={"check-box-circle" + (isBefore ? " _checked" : "")}
                                                {...onClickHandler(() => beforeAfterClicked(true))}
                                            />
                                            <div
                                                className={"check-box-circle" + (!isBefore ? " _checked" : "")}
                                                {...onClickHandler(() => beforeAfterClicked(false))}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className="child"
                                    style={{
                                        width: "100%",
                                        maxHeight: "150px",
                                        height: "100%",
                                    }}

                                >
                                    <div className="content-wrapper">
                                        <div className="trigger-special-row">
                                            <img src={iconSunrise} alt="" />
                                            <img src={iconSunset} alt="" />
                                        </div>
                                        <div className="trigger-special-row">
                                            <small style={{color: "#fff"}}>{suntime.sunrise.slice(0, 5)}</small>
                                            <small style={{color: "#fff"}}>{suntime.sunset.slice(0, 5)}</small>
                                        </div>
                                        <div className="trigger-special-row">
                                            <div
                                                className={
                                                    "check-box-circle" + (triggerType === "sunrise" ? " _checked" : "")
                                                }
                                                {...onClickHandler(() => astronomicalTimeClicked(true))}
                                            />
                                            <div
                                                className={
                                                    "check-box-circle" + (triggerType === "sunset" ? " _checked" : "")
                                                }
                                                {...onClickHandler(() => astronomicalTimeClicked(false))}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="content-bottom">
                            <div className="content-wrapper">
                                <div className="content-line">
                                    <div className="day-container" {...onClickHandler(() => dayClicked(1))}>
                                        <div className={"check-box" + (selectedDays[1] ? " checked" : "")} />
                                        <span>{t("monday")}</span>
                                    </div>
                                    <div className="day-container" {...onClickHandler(() => dayClicked(2))}>
                                        <div className={"check-box" + (selectedDays[2] ? " checked" : "")} />
                                        <span>{t("tuesday")}</span>
                                    </div>
                                    <div className="day-container" {...onClickHandler(() => dayClicked(3))}>
                                        <div className={"check-box" + (selectedDays[3] ? " checked" : "")} />
                                        <span>{t("wednesday")}</span>
                                    </div>
                                    <div className="day-container" {...onClickHandler(() => dayClicked(4))}>
                                        <div className={"check-box" + (selectedDays[4] ? " checked" : "")} />
                                        <span>{t("thursday")}</span>
                                    </div>
                                </div>
                                <div className="content-line">
                                    <div className="day-container" {...onClickHandler(() => dayClicked(5))}>
                                        <div className={"check-box" + (selectedDays[5] ? " checked" : "")} />
                                        <span>{t("friday")}</span>
                                    </div>
                                    <div className="day-container" {...onClickHandler(() => dayClicked(6))}>
                                        <div className={"check-box" + (selectedDays[6] ? " checked" : "")} />
                                        <span>{t("saturday")}</span>
                                    </div>
                                    <div className="day-container" {...onClickHandler(() => dayClicked(0))}>
                                        <div className={"check-box" + (selectedDays[0] ? " checked" : "")} />
                                        <span>{t("sunday")}</span>
                                    </div>
                                    <div className="day-container" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="content-divider right">
                        {scenarios.map(scenario => (
                            <div className="content-wrapper" {...onClickHandler(() => setSelectedScenario(scenario))}>
                                <div className="left-container">
                                    <img src={iconScenario} alt="" />
                                    <span>{scenario.name}</span>
                                </div>
                                <div
                                    className={"check-box" + (selectedScenario === scenario ? " checked" : "")}
                                    style={{borderRadius: "50%"}}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            {renderKeyboard()}
            {renderNumpad()}
        </>
    )
});
